import React from "react";
import BannerImage from "../assets/images/banner-img.png";
// import { formatFromWei } from "../helpers/index";
const Banner = ({ balance, buyers }) => {
  const btnCss =
    "bg-primary py-2.5 px-3 md:px-6 rounded-full text-primary-text font-medium mx-2 text-sm md:text-xl uppercase min-w-[100px]";
  return (
    <section className="py-10">
      <div className="container ">
        <div className="grid grid-cols-1 md:grid-cols-2 py-10  items-center">
          <div className="md:text-left text-center">
            <h1 className="text-4xl md:text-[80px] font-bold  my-2 md:mt-8  md:mb-10 uppercase">
              Mozzle Doge
            </h1>
            <p className=" font-serif text-sm sm:text-lg md:text-xl mb-1 md:mb-4">
              50TH BUYER JACKPOT POOL
            </p>
            <h2 className="uppercase text-xl mb-2 font-bold">
              Jackpot Balance : {Number(balance).toFixed(6)} ETH
            </h2>
            <h2 className="uppercase text-xl mb-4 font-bold">
              Buyers Count : {Number(buyers%50)}
            </h2>
            <div className=" grid grid-flow-col justify-center md:justify-start gap-3 ">
              <button className={`${btnCss}`}>
                <a
                  href="https://www.dextools.io/app/ether/pair-explorer/0x2767dbd048d2fc9e1a1b253ce5cca00b40727b3d"
                  target="_blank"
                  rel="noreferrer"
                >
                  Chart
                </a>
              </button>
              <button className={`${btnCss}`}>
                <a
                  href="https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0xd82F3BD13862b23264F682c6b31070056c4B6dA8&chain=mainnet"
                  target="_blank"
                  rel="noreferrer"
                >
                  BUY Mozzle
                </a>
              </button>
            </div>
          </div>
          <div className="">
            <div className="max-w-[400px] w-full mx-auto">
              <img src={BannerImage} alt="" className="w-full" />
            </div>
          </div>
        </div>

        {/* <div className="mb-6 md:mb-10 relative">
          <img src={BannerImage} alt="" className="w-full max-w-5xl mx-auto" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
            <p className=" font-serif text-[10px] sm:text-lg md:text-xl mb-1 md:mb-4">
              50TH BUYER JACKPOT POOL
            </p>
            <h2 className="uppercase text-xs sm:text-4xl md:text-6xl lg:text-8xl font-bold">
              {balance} ETH
            </h2>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Banner;
